import { useEffect, useState } from "react";
import api from "@/lib/api";
import { AlertTriangle } from "lucide-react";
import { useAuth } from "@/lib/auth";

function formatDate(iso) {
  if (!iso) return "";
  try { return new Date(iso).toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" }); }
  catch { return iso; }
}

export const SubscriptionFooter = () => {
  const { subscriptionDisabled } = useAuth();
  const [info, setInfo] = useState(null);

  useEffect(() => {
    api.get("/me/usage").then(r => setInfo(r.data)).catch(() => {});
  }, []);

  if (subscriptionDisabled || !info || info.days_left == null || info.days_left > 30 || info.days_left < 0) return null;

  const days = info.days_left;
  const urgent = days < 7;
  const quando = days === 0 ? "scade oggi" : days === 1 ? "tra 1 giorno" : `tra ${days} giorni`;

  return (
    <footer
      data-testid="subscription-footer"
      className={`shrink-0 border-t px-6 py-2.5 flex items-center justify-center gap-2 text-sm ${
        urgent
          ? "bg-[#F5E4E4] border-[#E3C9C9] text-[#B24040] font-medium"
          : "bg-[#FBF6EE] border-[#EBDFCB] text-[#8A6A2F]"
      }`}>
      <AlertTriangle className="w-4 h-4 shrink-0" strokeWidth={1.6} />
      <span data-testid="subscription-footer-text">
        L'abbonamento scade il {formatDate(info.subscription_end)} ({quando})
      </span>
    </footer>
  );
};
